import { ObjectData } from "@simonbackx/simple-encoding";
import { SimpleError } from "@simonbackx/simple-errors";
/**
 * Points to a value in a object of type T that is filterable
 */
export class FilterDefinition {
    constructor(settings) {
        this.id = settings.id;
        this.name = settings.name;
        this.category = settings.category;
        this.description = settings.description;
        this.getValue = settings.getValue;
        this.explainFilter = settings.explainFilter;
    }
}
/**
 * A filter is an encodebale structure, that is associated with a specific definition
 */
export class Filter {
    clone() {
        const o = new ObjectData(this.encode({ version: 0 }), { version: 0 });
        return this.definition.decode(o);
    }
}
export class FilterDecoder {
    constructor(definitions) {
        this.definitions = definitions;
    }
    decode(data) {
        const definitionId = data.field("definitionId").string;
        const definition = this.definitions.find(d => d.id === definitionId);
        if (!definition) {
            throw new SimpleError({
                code: "invalid_definition",
                message: "De opgeslagen filter filtert op iets dat niet langer bestaat: " + definitionId,
                field: data.addToCurrentField("definitionId")
            });
        }
        return definition.decode(data);
    }
}
/**
 * Allow filters that are extendable on definitions that are saved in the contextx
 */
export class ExtendableFilterDecoder {
    constructor(definitions) {
        this.definitions = definitions;
    }
    decode(data) {
        var _a;
        const general = data.context;
        const extendedDefinitions = (_a = general.definitions) !== null && _a !== void 0 ? _a : [];
        return new FilterDecoder([...this.definitions, ...extendedDefinitions]).decode(data);
    }
    static saveDefinitionInContext(context, definition) {
        const general = context;
        if (!general.definitions) {
            general.definitions = [];
        }
        general.definitions.push(definition);
    }
}
//# sourceMappingURL=FilterDefinition.js.map